import { Group } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { PageLayout } from '../../components/page-layout/page-layout';
import { useFinancialsStore } from '../../store/financials-store/financials-store';
import { setView } from '../../store/financials-store/financials-store.actions';
import { View } from '../../store/financials-store/financials-store.type';
import { useGlobalStore } from '../../store/global-store/global-store';
import { baseWhite, secondaryBase } from '../../styles/design-tokens';
import { Button } from '../../ui-library/button/button';
import { Icon } from '../../ui-library/icon/icon';
import { H2 } from '../../ui-library/typography/typography';
import { MenuDrivenContainer } from '../menu-driven-container/menu-driven-container';
import { Charts } from './charts/charts';
import { Filters as ChartFilters } from './charts/filters';
import { Header } from './charts/header/header';
import { Overview as ChartsOverview } from './charts/overview';
import { Tabs } from './charts/tabs';
import { usePortfolioProjectsAndBoards, useSpending } from './financials.hooks';
import { Filters as TableFilters } from './table/filters';
import { getAvailableSpendingYears } from './table/helpers';
import { Overview as TableOverview } from './table/overview';
import { Table } from './table/table';

export function Financials() {
  const view = useFinancialsStore((state) => state.view);

  return view === View.Charts ? <FinancialsCharts /> : <FinancialsTable />;
}

function FinancialsCharts() {
  const [isSideFilterOpen, { toggle: toggleSideFilter }] = useDisclosure(true);
  return (
    <MenuDrivenContainer
      header={
        <Group justify="flex-start" style={{ width: '100%' }}>
          <Icon name="payments" color={secondaryBase} size={36} />
          <H2>Financials</H2>
        </Group>
      }
    >
      <PageLayout
        controlBar={<Header />}
        overview={{
          title: 'KPIs Overview',
          content: <ChartsOverview />,
        }}
        tabs={<Tabs />}
        sideFilters={{
          title: 'Filters',
          content: <ChartFilters setShow={toggleSideFilter} />,
          show: isSideFilterOpen,
          setShow: toggleSideFilter,
        }}
        mainSection={<Charts />}
      />
    </MenuDrivenContainer>
  );
}

function FinancialsTable() {
  const portfolio = useGlobalStore((state) => state.portfolio);
  const { data: spendingData } = useSpending(portfolio?.id);
  const availableYears = getAvailableSpendingYears(spendingData);

  const { data: projects } = usePortfolioProjectsAndBoards(portfolio?.id);

  const spendingDataByProject = (spendingData || []).filter((entry) =>
    projects?.some((p) => p.id === entry.project_id),
  );

  return (
    <MenuDrivenContainer
      header={
        <Group justify="flex-start" style={{ width: '100%' }}>
          <Button
            variant="secondary"
            onClick={() => setView(View.Charts)}
            radius="xl"
            size="xs"
            leftSection={<Icon name="arrow_back" color={baseWhite} size={16} />}
          >
            Back
          </Button>
          <H2>Edit Financial Data</H2>
        </Group>
      }
    >
      <PageLayout
        controlBar={null}
        overview={{
          title: 'KPIs Overview',
          content: <TableOverview spendingData={spendingDataByProject} />,
        }}
        sideFilters={{ title: 'Filters', content: <TableFilters availableYears={availableYears} />, width: 100 }}
        mainSection={<Table spendingData={spendingDataByProject} />}
      />
    </MenuDrivenContainer>
  );
}
